// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/f04bf45186c48bacd6bf.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"9f6cb822ff04c276ed38","133":"5402f7c2d69aa014c68b","134":"f9ad8bbbe1fe633f354a"}[chunkId] + ".chunk.js";
};